/* global Omise */
import axios from 'axios'
import React from 'react';
export const SendEmail = async (data) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_HOST_PATH}/api/email/send`, data)
        return response.data
    } catch (error) {
        console.error('Error sending email:', error)
        throw new Error('email',error.message);
    }
}
//{process.env.REACT_APP_OMISE_PUBLIC_KEY}

  export const CreateSource = async (paymentMethod, data) => {
    let source, card;

    // Validate necessary data for each payment method
    if (paymentMethod === 'truemoney_jumpapp') {
        if (!data.amount) {
            throw new Error("Missing required fields: 'amount' or 'tel' for truemoney_jumpapp");
        }
        source = {
            "amount": data.amount * 100,
            "currency": "THB",
        };

        return new Promise((resolve, reject) => {
            Omise.createSource('truemoney_jumpapp', source, (statusCode, response) => {
                if (statusCode !== 200) {
                    console.error('Error creating source:', response);
                    return reject(new Error(`Failed to create payment source. Status code: ${statusCode}`));
                }
                resolve(response);
            });
        });
    } else if (paymentMethod === "internet_banking_bay") {
        if (!data.name || !data.number || !data.month || !data.year || !data.cvv || !data.amount) {
            throw new Error("Missing required fields for internet_banking_bay");
        }
        card = {
            name: data.name,
            number: data.number,
            expiration_month :data.month, // แปลง month เป็น int
            expiration_year : data.year, // แปลง year เป็น int
            security_code: data.cvv,
            amount: data.amount * 100,
        };

        // console.log("card",card);

        return new Promise((resolve, reject) => {
            Omise.createToken('card', card, (statusCode, response) => {
                if (statusCode !== 200) {
                    console.error('Error creating source:', response);
                    return reject(new Error(`Failed to create payment source. Status code: ${statusCode}`));
                }
                resolve(response);
            });
        });
    }else if(paymentMethod === "mobile"){
        const mobile = {
            "amount": data.amount * 100,
            "currency": "THB",
            "type": data.type
          }
          return new Promise((resolve, reject) => {
            Omise.createSource(mobile.type, mobile, (statusCode, response) => {
                if (statusCode !== 200) {
                    console.error('Error creating source:', response);
                    return reject(new Error(`Failed to create payment source. Status code: ${statusCode}`));
                }
                resolve(response);
            });
        });
    }else {
        throw new Error("Unsupported payment method");
    }
};

export const GetBoatByName = async (data,token) =>{
    // console.log('Getting', data.boatname, token)
    try {
        const response = await axios.get(`${process.env.REACT_APP_HOST_PATH}/api/boat/name/${data.boatname}`,{headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            "ngrok-skip-browser-warning": "true"
        },});
        // console.log("GetBoatByName response", response.data);
        return response.data[0];
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};

export const CheckBoat = async (date, time) => {
    try {
    //   console.log(`${process.env.REACT_APP_HOST_PATH}/${date}/${time}`);
      const response = await axios.get(`${process.env.REACT_APP_HOST_PATH}/api/booking/ticket/count/${date}/${time}`,{
        headers: {
            'Content-Type': 'application/json',
            
            "ngrok-skip-browser-warning": "true"
        },
      });
    //   console.log("CheckBoat response", response.data);
      
      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  };

export const AddTicketboat = async (data) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_HOST_PATH}/api/booking/ticket/create`, data, {
            headers: {
                'Content-Type': 'application/json',
                "ngrok-skip-browser-warning": "true"
                
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error adding ticket boat:', error);
        if (error.response) {
            throw new Error(`Failed to add ticket boat: ${error.response.data.message || 'Unknown error'}`)
        } else if (error.request) {
            throw new Error('No response received from server. Please check your connection.')
        } else {
             throw new Error('Failed to add ticket boat. Please try again.')
        }
    }
};

export const Getpayment = async (data) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_HOST_PATH}/api/payment/payment`, data, {
            headers: {
                'Content-Type': 'application/json',
                "ngrok-skip-browser-warning": "true"
            },
        });
        // console.log(response.data);
        return response.data;
    } catch (error) {
        console.error('Error getting payment:', error);
        if (error.response) {
            throw new Error(`Payment error: ${error.response.data.message || 'Unknown error'}`)
            // return []
        } else if (error.request) {
            throw new Error('No response received from payment server. Please try again.')
            // return []
        } else {
            throw new Error('Failed to process payment. Please try again.')
            // return []
        }
    }
};

export const getBookingByDate = async (data,token) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_HOST_PATH}/api/booking/ticket/date/${data}`,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                "ngrok-skip-browser-warning": "true"
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error getting bookings:', error);
        throw error;
    }
};

export const UpdateBooking = async (data,token) =>{
    // console.log('Updating bookings',data);
    try {
        const response = await axios.put(`${process.env.REACT_APP_HOST_PATH}/api/booking/update/${data.id}`, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                "ngrok-skip-browser-warning": "true"
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error updating booking:', error);
        throw error;
    }
}

export const getBookingByID = async (body) =>{
    try {
        // console.log('body', body);
        const token = body.token;
        const response = await axios.get(`${process.env.REACT_APP_HOST_PATH}/api/booking/ticket/id/${body.id}`);
        return response.data;
    } catch (error) {
        console.error('Error getting booking:', error);
        throw error;
    }
}

export const getBookingByUUID = async (body) =>{
    try {
        // console.log('body', body);
        const token = body.token;
        const response = await axios.get(`${process.env.REACT_APP_HOST_PATH}/api/booking/ticket/uuid/${body.id}`);
        return response.data;
    } catch (error) {
        console.error('Error getting booking:', error);
        throw error;
    }
}

export const getCountTicketByDate = async (date,token) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_HOST_PATH}/api/booking/ticket/date/count/${date}`,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                "ngrok-skip-browser-warning": "true"
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error getting booking:', error);
        throw error;
    }
};

export const GetAllBookings = async (token) =>{
    try {
        const response = await axios.get(`${process.env.REACT_APP_HOST_PATH}/api/booking/ticket`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                "ngrok-skip-browser-warning": "true"
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error getting all bookings:', error);
        throw error;
    }
}

//update bookings
export const CheckInApi = async (data,token) => {
    try {
        const res = await axios.put(`${process.env.REACT_APP_HOST_PATH}/api/booking/checkin/${data.id}`,data,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        });
    } catch (error) {
        console.error('Error getting all bookings:', error);
        throw error;
    }
};

export const CreateBookingVIP = async (data,token) => {
    try {
        const res = await axios.post(`${process.env.REACT_APP_HOST_PATH}/api/booking/ticket/vip/create`,data,{
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        });
        return res.data;
    } catch (error) {
        console.error('Error getting all bookings:', error);
        throw error;
    }
};

export const searchBookings = async (data,token) => {
    try {
        const response = await axios.get(
          `${process.env.REACT_APP_HOST_PATH}/api/booking/ticket/search`,
          {
            headers: {
              "ngrok-skip-browser-warning": "true",
              Authorization: `Bearer ${token}`,
            },
            params: data, // Pass data as params
          }
        );
        return response.data;
      } catch (error) {
        console.error('Error fetching data:', error);
        throw new Error(error.response?.data?.message || 'Failed to fetch data');
      }
};

export const GetVersionbyBooking = async (id) => {
    try {
        const response = await axios.get(
          `${process.env.REACT_APP_HOST_PATH}/api/booking/ticket/version/id/${id}`,
          {
            headers: {
              "ngrok-skip-browser-warning": "true",
              
            },
          }
        );
        return response.data;
      } catch (error) {
        console.error('Error fetching data:', error);
        throw new Error(error.response?.data?.message || 'Failed to fetch data');
      }
}

export const GetBookingDataByIdVersion = async (id,ver) =>{
    try {
        const response = await axios.get(
          `${process.env.REACT_APP_HOST_PATH}/api/booking/ticket/version/id/${id}/version/${ver}`,
          {
            headers: {
              "ngrok-skip-browser-warning": "true",
              
            },
          }
        );
        return response.data;
  
    } catch (error) {
        console.error('Error fetching data GetBookingDataByIdVersion:', error);
        throw new Error(error.response?.data?.message || 'Failed to fetch data GetBookingDataByIdVersion');
    }
}

export const GetBookingVersionHistory = async (id,token) =>{
    try {
        const response = await axios.get(
          `${process.env.REACT_APP_HOST_PATH}/api/booking/ticket/version/history/id/${id}`,
          {
            headers: {
              "ngrok-skip-browser-warning": "true",
              'Authorization': `Bearer ${token}`
            },
          }
        );
        return response.data;
    }catch (error){
        console.error('Error fetching data  GetBookingVersionHistory :', error);
        throw new Error(error.response?.data?.message || 'Failed to fetch data  GetBookingVersionHistory ');
    }
    
}